












































































import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {ContentPack, CurrentGame} from "../../../../types";
// @ts-ignore
import store from "../../../store";
@Component({
    components: {},
})

export default class MafiaIntro extends Vue {

    /**
     * Является ли игрок гостем
     * @private
     */
    private get isGuest(): boolean
    {
        return store.getters.getPlayerConnectionStatus === 'guest';
    }

    /**
     * Текущая игра
     * @private
     */
    private get currentActivity(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    private get contentPackId(): number
    {
        return store.getters.getGameState.tasks.state.content_pack_id;
    }

    private get currentPack(): ContentPack|null
    {
        if (!this.currentActivity) {
            return null;
        }

        const filtered = this.currentActivity.contentPacks.filter((pack: ContentPack) => {
            return pack.id === this.contentPackId;
        })

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }

        return null;
    }

    /**
     * Закончить интро, запустить
     * @private
     */
    private closeIntro(): void
    {
        this.$emit('close-intro');
    }
}
